import { DateTime } from '@ksyos/date-time';
import { Box, Icon } from '@ksyos/design-system';
import { useState } from 'react';
import { useTheme } from 'styled-components';
import { translateKey } from '@frontend/translate';
import { OutclinicDashboardSnoozeModal } from './OutclinicDashboardSnoozeModal';

interface IOutclinicDashboardSnoozeProps {
    processId: string;
    processNumber?: number;
    setSnoozeStatus: (processId: string, isSnoozed: boolean, snoozedUntilDateTime?: string) => void;
    snoozedUntilDateTime?: string;
}

export function OutclinicDashboardSnooze(props: IOutclinicDashboardSnoozeProps) {
    const theme = useTheme();
    const title = props.snoozedUntilDateTime
        ? translateKey(
              'outclinicDashboard.snoozedUntil',
              DateTime.from(props.snoozedUntilDateTime).format('DD-MM-YYYY')
          )
        : translateKey('outclinicDashboard.snoozeProcess');
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Box
                mr={2}
                onClick={() => {
                    setIsOpen(true);
                }}
                padding={2}
                sx={{
                    '&:hover': {
                        svg: {
                            color: theme.colors.neutral700,
                        },
                    },
                    cursor: 'pointer',
                }}
                title={title}
            >
                <Icon
                    color="minimal"
                    icon={props.snoozedUntilDateTime ? 'play' : 'pause'}
                />
            </Box>

            <OutclinicDashboardSnoozeModal
                {...props}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
            />
        </>
    );
}
